// @flow
import * as React from "react";
import {connect} from "react-redux";
import type {StoreState} from "../reducers/combinedReducers";
import {computeUserConfigs} from "../helpers/utils";
import type {RoleConfig} from "../types/utilityTypes";

function auth(check: (roleConfig: RoleConfig) => boolean) {

    return function Auth(WrappedComponent: React.ComponentType<any>): React.ComponentType<any> {

        function Authorize(props: any & {roleConfig: RoleConfig}) {

            if (check(props.roleConfig)) {
                return (
                    <WrappedComponent {...props} />
                );
            } else {
                return (
                    <div>Unauthorized</div>
                );
            }
        }

        Authorize.displayName = `Authorize(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

        return connect((state: StoreState): { roleConfig: RoleConfig } => ({roleConfig: computeUserConfigs(state.loginUser.roleIds)}))(Authorize);
    }
}

export default auth;


// WEBPACK FOOTER //
// ./src/hoc/Authorize.js